module.exports = __webpack_public_path__ + "static/media/07.d89993a0.svg";